import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const dailyMessageApi = createApi({
  reducerPath: "dailyMessageApi",

  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    credentials: "include",
  }),

  endpoints: (builder) => ({
  /* Generate Today's Message */

  generateDailyMessage:
    builder.mutation({
      query: (data = {}) => ({
        url:
          "/daily-message/generate",

        method: "POST",

        body: data,
      }),
    }),

  /* Save Message Format */

  saveDailyMessageTemplate:
    builder.mutation({
      query: (data) => ({
        url:
          "/daily-message/template",

        method: "POST",

        body: data,
      }),
    }),
}),
});

export const {
   useGenerateDailyMessageMutation,
  useSaveDailyMessageTemplateMutation
} = dailyMessageApi;

export default dailyMessageApi;